<i18n
  src="@/locales/views/agro_exporter/liquidations/query_by_provider/show_provider.yml"
  lang="yaml"
></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('show_process_providers')"
    :params="{
      agro_exporter_id: agro_exporter_id,
      agro_exporter_process_id: agro_exporter_process_id
    }"
  />

  <template v-if="load_general_data">
    <bread-crumbs
      :labels="[
        module_name,
        agro_exporter_process.name,
        provider.fullname || provider.name
      ]"
    />

    <div class="mt-6 px-4">
      <tabs-container v-model="option_tabs" :with_routing="true" />
    </div>

    <div v-if="show_provider">
      <router-view
        :liquidations_monthly="liquidations_monthly"
        :total_advances="total_advances"
        :totals_monthly="totals_monthly"
        :crop_sizes="crop_sizes"
        :totals_weekly="totals_weekly"
        :crop_size_labels="crop_size_labels"
        :crop_size_weekly="crop_size_weekly"
        :crop_size_earning_weekly="crop_size_earning_weekly"
        :exported_batches="liquidations"
        :total_exported_batche="total_liquidations"
      ></router-view>
    </div>
  </template>
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/liquidations/query_by_provider/show_provider.js";

export default {
  name: "AELiquidationsQueryByProviderShowProvider",
  props: {
    agro_exporter_id: { required: true },
    agro_exporter_process_id: { required: true },
    provider_id: { required: true },
    provider_type: { required: true }
  },
  data() {
    return {
      option_tabs: [],
      current_page: 1,
      total_liquidations: 0,
      rows_per_page: 12,
      load_general_data: false,
      load_data_summary: false,
      load_data_weekly: false,
      load_data_details: false,
      agro_exporter_process: {},
      provider: {},
      liquidations: [],
      liquidations_monthly: {},
      totals_monthly: {},
      total_advances: 0,
      crop_sizes: {},
      crop_size_labels: [],
      totals_weekly: {},
      crop_size_weekly: {},
      crop_size_earning_weekly: {},
    };
  },
  computed: {
    show_provider: function () {
      const route_name = this.$route.name;
      if (
        (route_name == this.routeName("show_provider_summary") &&
          this.load_data_summary) ||
        (route_name == this.routeName("show_provider_weekly") &&
          this.load_data_weekly) ||
        (route_name == this.routeName("show_provider_details") &&
          this.load_data_details)
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    loadData: async function () {
      this.fillOptions();
      await this.fetchAgroExporterProcess();
      await this.fetchProvider();
      this.loadDataReports();
      this.load_general_data = true;
    },
    loadDataReports: function () {
      if (this.option_tabs[0].current && !this.load_data_summary)
        this.loadDataSummary();
      if (this.option_tabs[1].current && !this.load_data_weekly)
        this.loadDataWeekly();
      if (this.option_tabs[2].current && !this.load_data_details)
        this.loadDataDetails();
    },
    loadDataSummary: async function () {
      await this.fetchLiquidationMonthly();
      await this.fetchTotalAdvances();
      await this.fetchTotalsMonthly();
      await this.fetchCropSizes();
      this.load_data_summary = true;
    },
    loadDataWeekly: async function () {
      await this.fetchTotalsWeekly();
      await this.fetchCropSizeLabels();
      await this.fetchCropSizeWeekly();
      await this.fetchCropSizeEarningWeekly();
      this.load_data_weekly = true;
    },
    loadDataDetails: async function () {
      this.load_data_details = true;
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchProvider: async function () {
      let response = await Requester.fetchProvider(
        this.agro_exporter_id,
        this.agro_exporter_process_id,
        this.provider_type,
        this.provider_id
      );
      this.provider = response.data;
    },
    fetchLiquidationMonthly: async function () {
      let response = await Requester.fetchLiquidationMonthly(
        this.agro_exporter_id,
        this.agro_exporter_process_id,
        this.provider_type,
        this.provider_id
      );
      this.liquidations_monthly = response.data;
    },
    fetchTotalAdvances: async function () {
      let response = await Requester.fetchTotalAdvances(
        this.agro_exporter_id,
        this.agro_exporter_process_id,
        this.provider_type,
        this.provider_id
      );
      this.total_advances = response.data;
    },
    fetchTotalsMonthly: async function () {
      let response = await Requester.fetchTotalsMonthly(
        this.agro_exporter_id,
        this.agro_exporter_process_id,
        this.provider_type,
        this.provider_id
      );
      this.totals_monthly = response.data;
    },
    fetchCropSizes: async function () {
      let response = await Requester.fetchCropSizes(
        this.agro_exporter_id,
        this.agro_exporter_process_id,
        this.provider_type,
        this.provider_id
      );
      this.crop_sizes = response.data;
    },
    fetchCropSizeLabels: async function () {
      let response = await Requester.fetchCropSizeLabels(
        this.agro_exporter_id,
        this.agro_exporter_process_id,
        this.provider_type,
        this.provider_id
      );
      this.crop_size_labels = response.data;
    },
    fetchTotalsWeekly: async function () {
      let response = await Requester.fetchTotalsWeekly(
        this.agro_exporter_id,
        this.agro_exporter_process_id,
        this.provider_type,
        this.provider_id
      );
      this.totals_weekly = response.data;
    },
    fetchCropSizeWeekly: async function () {
      let response = await Requester.fetchCropSizeWeekly(
        this.agro_exporter_id,
        this.agro_exporter_process_id,
        this.provider_type,
        this.provider_id
      );
      this.crop_size_weekly = response.data;
    },
    fetchCropSizeEarningWeekly: async function () {
      let response = await Requester.fetchCropSizeEarningWeekly(
        this.agro_exporter_id,
        this.agro_exporter_process_id,
        this.provider_type,
        this.provider_id
      );
      this.crop_size_earning_weekly = response.data;
    },
    fetchLiquidations: async function () {
      let response = await Requester.fetchLiquidations(
        this.agro_exporter_id,
        this.agro_exporter_process_id,
        this.provider_type,
        this.provider_id,
        this.current_page,
        this.rows_per_page
      );
      this.liquidations = response.data;
      this.fillPercentValues();
    },
    fetchLiquidationsTotal: async function () {
      let response = await Requester.fetchLiquidationsTotal(
        this.agro_exporter_id,
        this.agro_exporter_process_id,
        this.provider_type,
        this.provider_id
      );
      this.total_liquidations = response.data;
    },
    fillPercentValues() {
      this.liquidations.forEach(exported_batch => {
        const discarded_percent = this.discardPercent(exported_batch);
        exported_batch["discarded_percent"] = discarded_percent;
        exported_batch["ok_percent"] = 100 - discarded_percent;
      });
    },
    discardPercent(exported_batch) {
      let percent =
        (Number(exported_batch.discarded_weight) /
          Number(exported_batch.total_weight)) *
        100;
      return Math.round(percent);
    },
    fillOptions: function () {
      this.option_tabs = [
        {
          name: this.$t("labels.tabs.summary"),
          icon: "fa-solid fa-chart-pie",
          route: { name: this.routeName("show_provider_summary") },
          current: this.$route.name == this.routeName("show_provider_summary")
        },
        {
          name: this.$t("labels.tabs.weekly"),
          icon: "fa-solid fa-chart-line",
          route: { name: this.routeName("show_provider_weekly") },
          current: this.$route.name == this.routeName("show_provider_weekly")
        },
        {
          name: this.$t("labels.tabs.details"),
          icon: "fa-solid fa-list",
          route: { name: this.routeName("show_provider_details") },
          current: this.$route.name == this.routeName("show_provider_details")
        }
      ];
    }
  },
  watch: {
    option_tabs() {
      this.loadDataReports();
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => this.loadData())
    );
  }
};
</script>
